import { TTransactionGeneralLedgerCode } from '@/context/types/Business';

export const generateOption = (option: TTransactionGeneralLedgerCode) => ({
  label: `${option.code} - ${option.name}`,
  value: option.id,
  code: option.code,
  color: option.color
});
